import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgToolParticipantSearch = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "a",
		style: { maskType: "luminance" },
		maskUnits: "userSpaceOnUse",
		x: 2,
		y: 2,
		width: 20,
		height: 20,
		children: /* @__PURE__ */ _jsx("path", {
			d: "M2 2h20v20H2V2Z",
			fill: "white"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#a)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M10.287 10.02c.52 0 .962-.184 1.327-.548.364-.364.546-.807.546-1.327 0-.52-.182-.962-.546-1.327a1.807 1.807 0 0 0-1.327-.546c-.52 0-.963.182-1.327.546a1.807 1.807 0 0 0-.547 1.327c0 .52.183.963.547 1.327.364.364.807.547 1.327.547Zm.01 4.28c.7 0 1.364-.14 1.994-.42a5.074 5.074 0 0 0 1.668-1.204 7.754 7.754 0 0 0-1.807-.787 6.7 6.7 0 0 0-1.855-.265 7.17 7.17 0 0 0-1.973.27c-.632.18-1.199.44-1.7.782a4.948 4.948 0 0 0 1.664 1.204 4.9 4.9 0 0 0 2.009.42Zm10.575 7.71-5.33-5.33a9.17 9.17 0 0 1-2.427 1.405c-.859.332-1.802.497-2.828.497-2.316 0-4.277-.804-5.885-2.41-1.607-1.609-2.411-3.572-2.411-5.886s.804-4.276 2.411-5.884C6.01 2.794 7.972 1.99 10.287 1.99s4.276.804 5.884 2.412c1.608 1.608 2.412 3.57 2.412 5.884 0 1.027-.166 1.971-.497 2.834a9.15 9.15 0 0 1-1.405 2.432L22 20.872l-1.128 1.138Zm-10.585-5.033c1.852 0 3.43-.652 4.734-1.956 1.304-1.304 1.956-2.882 1.956-4.735 0-1.853-.652-3.43-1.956-4.734-1.303-1.304-2.882-1.956-4.734-1.956-1.853 0-3.431.652-4.735 1.956-1.304 1.303-1.956 2.881-1.956 4.734 0 1.853.652 3.431 1.956 4.735 1.304 1.304 2.882 1.956 4.735 1.956Z",
			fill: "currentColor"
		})
	})]
});
export default SvgToolParticipantSearch;
